export function extractQueryParam(
  search: string | undefined,
  targetParam: string
) {
  if (search === undefined || search === '') return [undefined, undefined];

  search = decodeURIComponent(search);
  const params = new URLSearchParams(search);
  let param;
  if (params.has(targetParam)) {
    param = params.get(targetParam) || undefined;
    params.delete(targetParam);
  }

  const modifiedParams = params.toString();
  return [param, modifiedParams ? `?${modifiedParams}` : undefined];
}
